"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var mountIsland_1 = require("../mountIsland");
var HtmlEditorWithValue_jsx_1 = __importDefault(require("../Generic/HtmlEditorWithValue.jsx"));
// The editor offers ONLY controls whose effect survives the server-side sanitizer. No font, size
// or colour picker: those emit nothing but <span style>, which FaqHtml strips because the answer
// is echoed unescaped onto a public page and symfony/html-sanitizer cannot validate CSS. Offering
// a control whose choice is silently discarded on save is worse than not offering it.
var TOOLBAR = {
    options: ['inline'],
    inline: { options: ['bold', 'italic', 'underline'] },
};
// ─── Component ────────────────────────────────────────────────────────────────
function FaqForm(_a) {
    var _this = this;
    var faq = _a.faq, locale = _a.locale, endpointStore = _a.endpointStore, endpointUpdate = _a.endpointUpdate, mode = _a.mode;
    var _b = (0, react_1.useState)(null), form = _b[0], setForm = _b[1];
    // Initialize form once faq and locale props are ready
    (0, react_1.useEffect)(function () {
        setForm({
            locale: locale || 'en',
            question: (faq === null || faq === void 0 ? void 0 : faq.question) || '',
            answer_html: (faq === null || faq === void 0 ? void 0 : faq.answer_html) || '',
            is_video: (faq === null || faq === void 0 ? void 0 : faq.is_video) ? 1 : 0,
            video_id: (faq === null || faq === void 0 ? void 0 : faq.video_id) || '',
            sort_order: (faq === null || faq === void 0 ? void 0 : faq.sort_order) || 0,
            is_active: (faq === null || faq === void 0 ? void 0 : faq.is_active) ? 1 : 0,
        });
    }, [faq, locale]);
    var handleChange = function (e) {
        var target = e.target;
        var name = target.name, value = target.value, type = target.type;
        var checked = type === 'checkbox' ? target.checked : undefined;
        setForm(function (prev) {
            var _a;
            return prev ? (__assign(__assign({}, prev), (_a = {}, _a[name] = type === 'checkbox' ? (checked ? 1 : 0) : value, _a))) : prev;
        });
    };
    var handleSelectChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setForm(function (prev) {
            var _a;
            return prev ? (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a))) : prev;
        });
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var endpoint, method;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    endpoint = mode === 'edit' ? endpointUpdate : endpointStore;
                    method = mode === 'edit' ? 'put' : 'post';
                    return [4 /*yield*/, (0, axios_1.default)({ method: method, url: endpoint, data: form })];
                case 1:
                    _a.sent();
                    setTimeout(function () {
                        // Preserve filter state by getting current URL params from referrer or using form locale
                        var referrerParams = new URLSearchParams(document.referrer.split('?')[1] || '');
                        var preservedLocale = referrerParams.get('locale') || (form === null || form === void 0 ? void 0 : form.locale) || 'en';
                        var preservedType = referrerParams.get('type') || ((form === null || form === void 0 ? void 0 : form.is_video) === 1 ? 'video' : 'text');
                        var returnParams = new URLSearchParams();
                        returnParams.set('locale', preservedLocale);
                        returnParams.set('type', preservedType);
                        window.location.href = "/app/admin/faqs?".concat(returnParams.toString());
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!form) {
        return null;
    }
    return (react_1.default.createElement(Box_1.default, { component: "form", onSubmit: handleSubmit, sx: { maxWidth: 600, display: 'flex', flexDirection: 'column', gap: 3 } },
        react_1.default.createElement(FormControl_1.default, { fullWidth: true },
            react_1.default.createElement(InputLabel_1.default, { id: "locale-label" }, "Locale"),
            react_1.default.createElement(Select_1.default, { labelId: "locale-label", label: "Locale", name: "locale", value: form.locale, onChange: handleSelectChange },
                react_1.default.createElement(MenuItem_1.default, { value: "en" }, "English"),
                react_1.default.createElement(MenuItem_1.default, { value: "es" }, "Espa\u00F1ol"),
                react_1.default.createElement(MenuItem_1.default, { value: "pt" }, "Portugu\u00EAs"))),
        react_1.default.createElement(TextField_1.default, { label: "Question", name: "question", value: form.question, onChange: handleChange, required: true, fullWidth: true }),
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { mb: 1 } }, "Answer"),
            react_1.default.createElement(Box_1.default, { sx: { border: '1px solid', borderColor: 'divider', p: 1, borderRadius: 1 } },
                react_1.default.createElement(HtmlEditorWithValue_jsx_1.default, { value: form.answer_html, toolbar: TOOLBAR, onHtmlEditorStateChange: function (html) {
                        setForm(function (prev) { return prev ? (__assign(__assign({}, prev), { answer_html: html })) : prev; });
                    } })),
            react_1.default.createElement(Typography_1.default, { variant: "caption", sx: { color: 'text.secondary' } }, "Bold, italic and underline. Fonts, sizes and colours are set by the page's design, not here.")),
        react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { name: "is_video", checked: form.is_video === 1, onChange: handleChange }), label: "Display in Video Section" }),
        react_1.default.createElement(TextField_1.default, { label: "Video ID (optional)", name: "video_id", value: form.video_id, onChange: handleChange, fullWidth: true }),
        react_1.default.createElement(TextField_1.default, { label: "Sort Order", name: "sort_order", type: "number", value: form.sort_order, onChange: handleChange, fullWidth: true }),
        react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { name: "is_active", checked: form.is_active === 1, onChange: handleChange }), label: "Is Active?" }),
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(Button_1.default, { type: "submit", variant: "contained", color: "primary" },
                mode === 'edit' ? 'Update' : 'Create',
                " FAQ"))));
}
// ─── Mount directly from Blade ────────────────────────────────────────────────
var el = document.getElementById('faq-form-root');
if (el) {
    var faq = null;
    try {
        faq = el.dataset.faq ? JSON.parse(el.dataset.faq) : null;
    }
    catch (e) {
        console.error('Invalid FAQ JSON:', e);
    }
    var locale = el.dataset.locale || 'en';
    var endpointStore = el.dataset.endpointStore || '';
    var endpointUpdate = el.dataset.endpointUpdate || '';
    var mode = (el.dataset.mode || 'create');
    (0, mountIsland_1.mountIsland)(el, react_1.default.createElement(FaqForm, { faq: faq, locale: locale, endpointStore: endpointStore, endpointUpdate: endpointUpdate, mode: mode }));
}
